<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    title="续费成功"
    :footer-hide="true"
    width="800"
    class="my-modal top p-b"
  >
    <div class="follow-up-container">
      <div class="fee-status">
        <Form ref="form" :model="form" :label-width="80" class="modal-form" :rules="ruleInline">
          <Table :columns="columns" :data="form.commissionDTOList">
            <template slot-scope="{ row,index }" slot="fee">
              <Input v-model="row.fee" placeholder="请填写" @on-change="form.commissionDTOList[index].fee = row.fee" @on-blur='payableTotal("fee")'></Input>
            </template>

            <template slot-scope="{ row, index }" slot="payFee">
              <FormItem class="form-item" :prop='"commissionDTOList." + index + ".payFee"' :rules="{required: true, message: '请输入', trigger: 'blur'}">
                <Input v-model="row.payFee" placeholder="请填写" @on-change="form.commissionDTOList[index].payFee = row.payFee" @on-blur='payableTotal("payFee")'></Input>
              </FormItem>
            </template>
          </Table>
          <div class="total">
            <div>合计</div>
            <div>{{feeTotal?feeTotal:''}}</div>
            <div>{{payFeeTotal?payFeeTotal:''}}</div>
          </div>
            
          <FormItem prop="serverEndDate" label="续费时间">
            <DatePicker
              type="date"
              split-panels
              v-model="form.serverEndDate"
              placeholder="请选择"
              :transfer="true"
            ></DatePicker>
          </FormItem>
        </Form>
      </div>

      <div class="action-buttom">
        <div class="buttom-box">
          <Button class="cancel" @click="visible=false">取消</Button>
          <Button type="primary" @click="ok">确认</Button>
        </div>        
      </div>
    </div>
  </Modal>
</template>

<script>
import filters from "@/api/filter";
export default {
  props: ["id", 'getInsureList'],
  data() {
    return {
      commissionDTOList: [],
      visible: false,
      columns: [
        {
          title: "险种名称",
          key: "productName",
          align: "center",
        },
        {
          title: "应缴保费(元)",
          align: "center",
          slot: "fee",
        },
        {
          title: "实缴保费(元)",
          align: "center",
          slot: "payFee",
        },
      ],
      form: {},
      ruleInline: {
        serverEndDate: [
          {
            required: true,
            type: "date",
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
      feeTotal: "", //应缴总计
      payFeeTotal: "", //实缴总计
    };
  },

  methods: {
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      this.form = data;
      this.form.commissionDTOList = data.commissionDTOList&&data.commissionDTOList.map((item) => {
        return {
          ...item,
          fee: item.fee ? item.fee : "",
          payFee: item.payFee ? item.payFee : "",
        };
      });
      this.commissionDTOList = this.form.commissionDTOList;

      this.feeTotal = this.commissionDTOList&&this.commissionDTOList.reduce(
        (sum, current) => sum.add(current["fee"]),
        0
      );
      this.payFeeTotal = this.commissionDTOList&&this.commissionDTOList.reduce(
        (sum, current) => sum.add(current["payFee"]),
        0
      );
      this.visible = true;
      this.$refs.form&&this.$refs.form.fields.forEach((v, i) => {
        v.validateDisabled = true;
        v.validateState = "";
        v.validateMessage = "";
      });
    },

    // 计算
    payableTotal(keys) {
      if (keys == "fee") {
        this.feeTotal = this.commissionDTOList.reduce(
          (sum, current) => sum.add(current[keys]),
          0
        );
      } else {
        this.payFeeTotal = this.commissionDTOList.reduce(
          (sum, current) => sum.add(current[keys]),
          0
        );
      }
    },

    ok() {
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        this.submit();
      });
    },

    submit() {
      let data = {
        id: this.form.id,
        serviceState: 2,
        payState: 2,//续费成功
        serverEndDate: this.form.serverEndDate
          ? filters.filterTime(this.form.serverEndDate, "YYYY-MM-DD")
          : "",//续费时间
        additionData: this.commissionDTOList,//附加险
      };
      this.$http({
        url: `/buz/policyRenewalRecord/updateRenewalRecord`,
        type: "POST",
        data,
        apiPermissionCode:'renewalManage_02_5'
      }).then((res) => {
        this.$notice.success("操作成功");
        this.form = {};
        this.getInsureList();
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-up-container {
  padding: 0 0 5px 10px;
  .fee-status {
    .total {
      display: flex;
      border: 1px solid #e8eaec;
      border-top: none;
      border-right: none;
      height: 40px;
      margin-bottom: 30px;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.3%;
        border-right: 1px solid #e8eaec;
      }
    }
    .failure-type {
      display: flex;
      flex-wrap: wrap;
      .failure-btn {
        width: 105px;
        height: 32px;
        border-radius: 4px;
        background: #f5f7f9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3c464f;
        font-size: 14px;
        margin-bottom: 10px;
        margin-right: 10px;
      }

      .failure-btn:hover {
        cursor: pointer;
      }

      & .active {
        background: rgba(235, 241, 255, 0.39);
        color: #236dff;
        border: 1px solid #236dff;
      }
    }
    /deep/ .ivu-form-item-content {
      margin-left: 0 !important;
    }
    .form-item {
      margin-top:15px;
      height: 43px;
    }
  }
}
.action-buttom {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  .buttom-box {
    width: 50%;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    Button {
      width: 140px;
      height: 36px;
    }
    .cancel {
      width: 120px;
      border-color: #236dff;
      color: #236dff;
    }
  }
}
</style>